// import React, { useState } from 'react';
// import Page from '../layout/Page';
// import Row from '../layout/Row';
// import Input from '../forms/Input';
// import Col from '../layout/Col';
// import { currency, formatCurrency, inputDate, shortHandDate } from '../utility/functions';
// import Heading from '../forms/Heading';

// const Prorate = ({ ...props }) => {

//     const [date, setDate] = useState(new Date());
//     const [parentBD, setParentBD] = useState(1);
//     const [childBD, setChildBD] = useState(13);
//     const price = 25;
//     const additional = 15;


//     const getBD = (BD) => {
//         const current = new Date(date)

//         if (current.getDate() < BD) {
//             return shortHandDate(new Date(current.setMonth(current.getMonth())).setDate(BD))
//         }


//         return shortHandDate(new Date(current.setMonth(current.getMonth() + 1)).setDate(BD))
//     }

//     const getLastBD = (BD) => {
//         const current = new Date(date)

//         if (current.getDate() < BD) {
//             return shortHandDate(new Date(current.setMonth(current.getMonth() - 1)).setDate(BD))
//         }


//         return shortHandDate(new Date(current.setMonth(current.getMonth())).setDate(BD))
//     }

//     const daysBetween = (date1, date2) => {
//         date1 = new Date(date1);
//         date2 = new Date(date2);

//         let timeDifference = date2.getTime() - date1.getTime();
//         let daysDifference = timeDifference / (1000 * 60 * 60 * 24);
//         return Math.floor(daysDifference);
//     }

//     const parentalPlan = daysBetween(date, getBD(parentBD));
//     const childPlan = daysBetween(date, getBD(childBD))

//     const childExpire = parentalPlan < childPlan;

//     const prorate = parentalPlan > childPlan ? parentalPlan - childPlan : childPlan - parentalPlan;

//     const proratedRate = (prorate / daysBetween(getLastBD(parentBD), getBD(parentBD))).toFixed(2);

//     const invoice = (childExpire ? additional - (proratedRate * additional) : additional + (proratedRate * additional))

//     return (
//         <Page title='Prorate Algorithm' pageBreak>
//             <Row>
//                 <Input
//                     label='Test Day'
//                     value={inputDate(date)}
//                     onInput={e => setDate(e.target.value)}
//                     type='date'
//                     standalone
//                 />
//                 <Input
//                     label='Parent Billing Day'
//                     value={parentBD}
//                     onInput={e => setParentBD(parseInt(e.target.value))}
//                     type='number'
//                     standalone
//                 />
//                 <Input
//                     label='Child Billing Day'
//                     value={childBD}
//                     onInput={e => setChildBD(parseInt(e.target.value || new Date().getDate()))}
//                     type='number'
//                     standalone
//                 />
//             </Row>

//             <Row align='flex-start' style={{ gap: '5em' }}>
//                 <Col justify='flex-start'>
//                     <Heading>Test Inputs</Heading>
//                     <Row justify='space-between'>
//                         <b>Testing Date:</b> {shortHandDate(date)}
//                     </Row>
//                     <Row justify='space-between'>
//                         <b>Package Price:</b> {formatCurrency(price)}
//                     </Row>
//                     <Row justify='space-between'>
//                         <b>Additional Car Price:</b> {formatCurrency(additional)}
//                     </Row>
//                 </Col>

//                 <Col>
//                     <Heading>Calculations</Heading>
//                     <Row justify='space-between'>
//                         <b>Parent Billing Date:</b> {getBD(parentBD)}
//                     </Row>
//                     <Row justify='space-between'>
//                         <b>Parent Last Billing Date:</b> {getLastBD(parentBD)}
//                     </Row>
//                     <Row justify='space-between'>
//                         <b>Parent Plan length:</b> {daysBetween(getLastBD(parentBD), getBD(parentBD))}
//                     </Row>
//                     <br />

//                     <Row justify='space-between'>
//                         <b>Child Billing Date:</b> {getBD(childBD)}
//                     </Row>
//                     <Row justify='space-between'>
//                         <b>Child Last Billing Date:</b> {getLastBD(childBD)}
//                     </Row>
//                     <Row justify='space-between'>
//                         <b>Child Plan length:</b> {daysBetween(getLastBD(childBD), getBD(childBD))}
//                     </Row>
//                     <br />

//                     <Row justify='space-between'>
//                         <b>Parent Days Left:</b> {parentalPlan}
//                     </Row>
//                     <Row justify='space-between'>
//                         <b>Child Days Left:</b> {childPlan}
//                     </Row>
//                     <br />

//                     <Row justify='space-between'>
//                         <b>Child Days Prorated:</b> {childExpire ? '-' : '+'} {prorate}
//                     </Row>

//                     <Row justify='space-between'>
//                         <b>Child Prorated Rate:</b> <span>{childExpire ? '-' : '+'}{Math.round(proratedRate * 100)}% ({formatCurrency(invoice)})</span>
//                     </Row>
//                     <Row justify='space-between'>
//                         <b>Next invoice:</b> <span>{formatCurrency(price + invoice)}</span>
//                     </Row>
//                 </Col>
//             </Row>
//         </Page>
//     );
// }

// export default Prorate;



import React, { useEffect, useLayoutEffect, useState } from 'react';
import Page from '../layout/Page';
import Row from '../layout/Row';
import Input from '../forms/Input';
import Col from '../layout/Col';
import { formatCurrency, inputDate, shortHandDate, shortHandDateTime, shortHandDateUTC } from '../utility/functions';
import Heading from '../forms/Heading';
import Button from '../forms/Button';

const Prorate = ({ ...props }) => {

    const [testDate, setTestDate] = useState(new Date());
    const [price, setPrice] = useState(25);
    const [ACP, setACP] = useState(15);

    const [parentBD, setParentBD] = useState(1);
    const [childBD, setChildBD] = useState(15);

    const daySelected = (date) => {
        const now = new Date();
        const selectedDate = date;
        const [year, month, day] = selectedDate.split('-').map(Number);
        return new Date(year, month - 1, day, (now.getTimezoneOffset() / 60));
    }

    const [parentNBD, setParentNBD] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1, parentBD)));
    const [childNBD, setChildNBD] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1, childBD)));
    // const [parentNBD, setParentNBD] = useState(daySelected(`${testDate.getFullYear()}-${testDate.getMonth() + 1}-${parentBD}`));
    // const [childNBD, setChildNBD] = useState(daySelected(`${testDate.getFullYear()}-${testDate.getMonth() + 1}-${childBD}`));

    const [output, setOutput] = useState({})

    const daysBetween = (date1, date2) => {
        date1 = new Date(date1);
        date2 = new Date(date2);

        const timeDifference = date2.getTime() - date1.getTime();
        const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
        return Math.abs(Math.floor(daysDifference));
    }

    const monthsBetween = (date1, date2) => {
        date1 = new Date(date1);
        date2 = new Date(date2);

        const yearDiff = date2.getFullYear() - date1.getFullYear();
        const monthDiff = date2.getMonth() - date1.getMonth();

        let totalMonths = (yearDiff * 12) + monthDiff;

        return Math.abs(totalMonths);
    };

    const monthsAndDaysBetween = (date1, date2) => {
        date1 = new Date(date1);
        date2 = new Date(date2);

        if (date1 > date2) {
            [date1, date2] = [date2, date1];
        }

        const yearDiff = date2.getFullYear() - date1.getFullYear();
        const monthDiff = date2.getMonth() - date1.getMonth();
        let totalMonths = (yearDiff * 12) + monthDiff;

        const adjustedDate1 = new Date(date1);
        adjustedDate1.setMonth(date1.getMonth() + totalMonths);

        const dayDiff = (date2 - adjustedDate1) / (1000 * 60 * 60 * 24);

        let days = Math.floor(dayDiff);
        if (days < 0) {
            totalMonths -= 1;
            const prevMonthDate = new Date(adjustedDate1);
            prevMonthDate.setMonth(adjustedDate1.getMonth() - 1);
            days = Math.floor((date2 - prevMonthDate) / (1000 * 60 * 60 * 24));
        }

        return { months: totalMonths, days: days };
    };



    useLayoutEffect(() => {
        if (new Date(testDate) > new Date(parentNBD))
            setParentNBD(new Date(new Date().setMonth(new Date(testDate).getMonth() + 1, parentBD)));
        if (new Date(testDate) > new Date(childNBD))
            setChildNBD(new Date(new Date().setMonth(new Date(testDate).getMonth() + 1, childBD)));
    }, [testDate, parentBD, childBD])

    useLayoutEffect(() => {
        setChildBD(new Date(childNBD).getDate())
        setParentBD(new Date(parentNBD).getDate())
    }, [parentNBD, childNBD])

    useLayoutEffect(() => {
        // console.clear();
        // console.log(parentNBD)

        const today = shortHandDate(testDate);
        const pp = formatCurrency(price);
        const acp = formatCurrency(ACP);

        const daysLeftInParent = daysBetween(testDate, parentNBD);
        const daysLeftInChild = daysBetween(testDate, childNBD);
        const overlap = daysBetween(parentNBD, childNBD) * (daysLeftInParent > daysLeftInChild ? 1 : -1);

        const nextMonthPlanLength = daysBetween(parentNBD, new Date(parentNBD).setMonth(new Date(parentNBD.getMonth() + 1)));

        const daysProrated = daysBetween(parentNBD, childNBD);
        const prorate = (overlap / nextMonthPlanLength);

        const regularPrice = formatCurrency(price + ACP);
        const proratedACP = formatCurrency(ACP + (ACP * prorate))
        const proratedInvoice = formatCurrency(price + ACP + (ACP * prorate))

        const costOfSignup = formatCurrency(ACP * prorate)

        const calculateProrate = (parentNextBillingDate, childNextBillingDate, packagePrice, additionalCarPrice) => {
            const todaysDate = new Date();
            const daysLeftInParent = daysBetween(todaysDate, parentNextBillingDate);
            const daysLeftInChild = daysBetween(todaysDate, childNextBillingDate);

            const nextMonthsPlanLength = new Date(parentNextBillingDate).setMonth(new Date(parentNextBillingDate.getMonth() + 1))
            const nextMonthPlanLength = daysBetween(parentNextBillingDate, nextMonthsPlanLength);

            const overlap = daysBetween(parentNextBillingDate, childNextBillingDate) * (daysLeftInParent > daysLeftInChild ? 1 : -1);

            const prorate = overlap / nextMonthPlanLength;

            return (packagePrice + additionalCarPrice + (additionalCarPrice * prorate))
        }

        setOutput({
            today,
            pp,
            acp,
            daysLeftInParent,
            daysLeftInChild,
            overlap,
            nextMonthPlanLength,
            prorate,
            daysProrated,
            regularPrice,
            proratedACP,
            proratedInvoice,
            costOfSignup,
        })



    }, [testDate, price, ACP, parentBD, childBD, parentNBD, childNBD])

    return (
        <Page title='Prorate Algorithm' pageBreak>
            <Row align='flex-start'>
                <Col>
                    <Input
                        label='Test Day'
                        value={inputDate(testDate)}
                        onInput={e => setTestDate(daySelected(e.target.value))}
                        min={new Date()}
                        type='date'
                        standalone
                    />
                    <Input
                        label='Package Price'
                        value={price}
                        onInput={e => setPrice(parseInt(e.target.value))}
                        min={0}
                        max={100}
                        type='range'
                        standalone
                    />
                    <Input
                        label='Additional Car Price'
                        value={ACP}
                        onInput={e => setACP(parseInt(e.target.value))}
                        min={0}
                        max={100}
                        type='range'
                        standalone
                    />
                </Col>

                <Col>
                    <Input
                        label='Parent Billing Day'
                        value={parentBD}
                        onInput={e => setParentBD(e.target.value)}
                        type='number'
                        min={1}
                        max={28}
                        standalone
                    />
                    <Input
                        label='Child Billing Day'
                        value={childBD}
                        onInput={e => setChildBD(e.target.value)}
                        type='number'
                        min={1}
                        max={28}
                        standalone
                    />
                </Col>

                <Col>
                    <Input
                        label='Parent Next Billing Day'
                        value={inputDate(parentNBD)}
                        onInput={e => setParentNBD(daySelected(e.target.value))}
                        min={new Date()}
                        type='date'
                        standalone
                    />
                    <Input
                        label='Child Next Billing Day'
                        value={inputDate(childNBD)}
                        onInput={e => setChildNBD(daySelected(e.target.value))}
                        min={new Date()}
                        type='date'
                        standalone
                    />
                </Col>

                <Col>
                    <Button
                        label='Fresh Child Signup'
                        onClick={() => setChildNBD(new Date(testDate))}
                    />
                </Col>
            </Row>
            <Row align='flex-start' gap='3em'>
                <Col>
                    <Heading>Today: {output.today}</Heading>
                    <Heading>Package Price: {output.pp}</Heading>
                    <Heading>Additional Car Price: {output.acp}</Heading>
                </Col>
                <Col>
                    <Heading>Days Left in parent Plan: {output.daysLeftInParent}</Heading>
                    <Heading>Days Left in child Plan: {output.daysLeftInChild}</Heading>
                    <Heading>Days Prorated: {Math.abs(output.overlap)}</Heading>
                </Col>
                <Col>
                    <Heading>Plan Length: {output.nextMonthPlanLength} Days</Heading>
                    <Heading>Days Prorated: {output.daysProrated}</Heading>
                    <Heading>Prorate: {Math.round((output.prorate || 0) * 100)}%</Heading>
                </Col>
                <Col>
                    <Heading>Regular Price: {output.regularPrice}</Heading>
                    <Heading>Plan Invoice: {output.pp} + ({output.proratedACP})</Heading>
                    <Heading>Next Invoice: {output.proratedInvoice}</Heading>
                    <Heading>Cost Of Signup: {output.costOfSignup}</Heading>
                </Col>
            </Row>
        </Page>
    );
}

export default Prorate;
